import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import moment from 'moment'

const initState = {
    startDisabled: false,
    endDisabled: false,
    startDate: utils.datetimeStartOfWithoutOffset(utils.currentDatetime(), 'day'),
    endDate: utils.datetimeEndOfWithoutOffset(utils.currentDatetime(), 'day'),
    label: {
        start: '',
        end: ''
    }
}

class DatetimeFromToSelect extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'DatetimeFromToSelect', options)
        }

        this.state = initState
    }

    componentDidMount() {
        if (this.props?.initDate) {
            initState.startDate = this.props.initDate.startAt
            initState.endDate = this.props.initDate.endAt
        }
        this.setState(initState)
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    isDateInvalid() {
        if (utils.isDateAfter(this.state.startDate, this.state.endDate)) return true

        return false
    }
    handleMaxDate() {
        let maxDate = moment().add(100, 'y')
        if (this.props?.dateLimit) {
            const today = utils.datetimeEndOfWithoutOffset(utils.currentDatetime(), 'day')
            const limitDate = moment(this.state.startDate).add(this.props.dateLimit.count, this.props.dateLimit.type)
            maxDate = moment(limitDate).isAfter(today, 'second') ? today : limitDate
        }
        if (this.props?.endDateMaxDate) {
            maxDate = this.props.endDateMaxDate
        }
        return maxDate
    }

    render() {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DateTimePicker
                    invalidDateMessage={this.t('DatePicker.invalidDateMessage')}
                    maxDateMessage={this.t('DatePicker.maxDateMessage')}
                    minDateMessage={this.t('DatePicker.minDateMessage')}
                    minDate={this.props.startDateMinDate}
                    maxDate={this.props.startMaxDate ?? this.state.endDate}
                    className={this.props.options?.hide ? this.props.classes.hide : this.props.classes.textField}
                    variant="inline"
                    value={this.state.startDate}
                    onChange={(date) =>
                        this.setState({
                            startDate: date,
                        })
                    }
                    views={['year', 'month', 'date', 'hours', 'minutes', 'seconds']}
                    format="yyyy/MM/dd HH:mm"
                    label={this.props.label?.start ? this.props.label?.start :  this.t('startDate')}
                    disabled={this.state.startDisabled}
                />
                <DateTimePicker
                    invalidDateMessage={this.t('DatePicker.invalidDateMessage')}
                    maxDateMessage={this.t('DatePicker.maxDateMessage')}
                    minDateMessage={this.t('DatePicker.minDateMessage')}
                    minDate={this.state.startDate}
                    maxDate={this.props.endMaxDate ?? this.handleMaxDate()}
                    className={this.props.options?.hide ? this.props.classes.hide : this.props.classes.textField}
                    variant="inline"
                    value={this.state.endDate}
                    onChange={(date) =>
                        this.setState({
                            endDate: date,
                        })
                    }
                    views={['year', 'month', 'date', 'hours', 'minutes']}
                    format="yyyy/MM/dd HH:mm"
                    label={this.props.label?.end ? this.props.label?.end :  this.t('endDate')}
                    disabled={this.state.endDisabled}
                />
            </MuiPickersUtilsProvider>
        )
    }
}

DatetimeFromToSelect.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    onRef: PropTypes.func.isRequired,
    options: PropTypes.object,
    startDateMinDate: PropTypes.any,
    dateLimit: PropTypes.object,
    endDateMaxDate: PropTypes.any,
    initDate: PropTypes.object,
    label: PropTypes.object,
    endMaxDate: PropTypes.any,
    startMaxDate: PropTypes.any
}

const styles = (theme) => {
    return {
        textField: {
            margin: theme.spacing(1),
            width: '150px',
        },
        hide: {
            display: 'none',
        },
    }
}

export default hoc(styles)(DatetimeFromToSelect)
